import { formatMoney } from 'accounting-js'
import React from 'react'
import { Link } from 'react-router-dom'

const AssetBillRow = ({bill}) => {

    const formatDate = (_d) =>{
      if(_d){
        let date = _d.toString()
        let dateCondition = date.split(" ")
        if (dateCondition.length > 1) {
            let dateArray = date.split(" ")

            if(dateArray[1] === 'Jan')
              dateArray[1] = '01'
            else if(dateArray[1] === 'Feb')
              dateArray[1] = '02'
            else if(dateArray[1] === 'Mar')
              dateArray[1] = '03'
            else if(dateArray[1] === 'Apr')
              dateArray[1] = '04'
            else if(dateArray[1] === 'May')
              dateArray[1] = '05'
            else if(dateArray[1] === 'Jun')
              dateArray[1] = '06'
            else if(dateArray[1] === 'Jul')
              dateArray[1] = '07'
            else if(dateArray[1] === 'Aug')
              dateArray[1] = '08'
            else if(dateArray[1] === 'Sep')
              dateArray[1] = '09'
            else if(dateArray[1] === 'Oct')
              dateArray[1] = '10'
            else if(dateArray[1] === 'Nov')
              dateArray[1] = '11'
            else if(dateArray[1] === 'Dec')
              dateArray[1] = '12'

            return dateArray[2]+"/"+dateArray[1]+"/"+dateArray[3]
        }
        else{
            let dateArray1 = date.split("T")
            let dateArray = dateArray1[0].split("-")
    
            if(dateArray[1] === 'Jan')
              dateArray[1] = '01'
            else if(dateArray[1] === 'Feb')
              dateArray[1] = '02'
            else if(dateArray[1] === 'Mar')
              dateArray[1] = '03'
            else if(dateArray[1] === 'Apr')
              dateArray[1] = '04'
            else if(dateArray[1] === 'May')
              dateArray[1] = '05'
            else if(dateArray[1] === 'Jun')
              dateArray[1] = '06'
            else if(dateArray[1] === 'Jul')
              dateArray[1] = '07'
            else if(dateArray[1] === 'Aug')
              dateArray[1] = '08'
            else if(dateArray[1] === 'Sep')
              dateArray[1] = '09'
            else if(dateArray[1] === 'Oct')
              dateArray[1] = '10'
            else if(dateArray[1] === 'Nov')
              dateArray[1] = '11'
            else if(dateArray[1] === 'Dec')
              dateArray[1] = '12'
    
            return dateArray[2]+"/"+dateArray[1]+"/"+dateArray[0]
        }
      }
      else
        return '-'
    }

  return (
    <tr>
        <td className="align-middle">
            {bill.billNumber ? bill.billNumber : '-'}
        </td>
        <td className="align-middle">
            {bill.billFolio ? bill.billFolio : '-'}
        </td>
        <td className="align-middle">
            {bill.billDate ? formatDate(bill.billDate) : '-'}
        </td>
        <td className="align-middle">
            {bill.billConcept ? bill.billConcept : '-'}
        </td>
        <td className="align-middle">
            {bill.billImport ? formatMoney(bill.billImport/100) : '-'}
        </td>
        <td className="align-middle">
            {
              bill.billFiles && bill.billFiles.length > 0
              ?
                bill.billFiles.map((b)=>
                  
                    <div>
                      <a
                        target="_blank"
                        href={b.url}
                      >
                        {b.name}
                      </a>
                      <br/>
                    </div>
                          
                )
              :
                null
            }
        </td>
    </tr>
  )
}

export default AssetBillRow


// WEBPACK FOOTER //
// src/modules/secured/modules/assets/AssetBillRow.js